import { forwardRef } from 'react';

import { IconProps } from './icon';

export const ArrowLeftIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size = 20, ...props }, ref) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" ref={ref} {...props} {...{ className }}>
      <path
        d="M12.2 13.63C12.3118 13.7472 12.3743 13.903 12.3743 14.065C12.3743 14.227 12.3118 14.3828 12.2 14.5L11.47 15.23C11.354 15.3442 11.1977 15.4082 11.035 15.4082C10.8722 15.4082 10.716 15.3442 10.6 15.23L5.80997 10.43C5.75251 10.3741 5.70685 10.3072 5.67567 10.2334C5.64448 10.1595 5.62842 10.0802 5.62842 10C5.62842 9.91984 5.64448 9.84049 5.67567 9.76663C5.70685 9.69278 5.75251 9.62592 5.80997 9.57001L10.6 4.77001C10.716 4.65581 10.8722 4.5918 11.035 4.5918C11.1977 4.5918 11.354 4.65581 11.47 4.77001L12.2 5.50001C12.3118 5.61721 12.3743 5.77299 12.3743 5.93501C12.3743 6.09703 12.3118 6.25282 12.2 6.37001L8.55997 10L12.2 13.63Z"
        fill="currentColor"
      />
    </svg>
  );
});

export default ArrowLeftIcon;
